import ListItemSchema from 'schemas/listItem.schema'
import { z } from 'zod'

const listItemValidator = ListItemSchema

export default listItemValidator

export type ListItemType = z.infer<typeof listItemValidator>
